export default function(){
    const handleGoBack = () => {
        window.history.back();
    };
    return<>
        <h3 className="text-parametres"><i onClick={handleGoBack} className="bi bi-arrow-left-short arrow"></i> Paramétres</h3>

    </>
}